import "./styles.scss";

/**
 * Render Page : NotFound
 *
 * @category Pages
 * @component
 * @returns { React.Component } A React component
 */

function NotFound() {
	return (
        <main>
            <h1>Je suis un H1</h1>
			<section>
				<h2>Je suis un H2</h2>
			</section>
		</main>
    );
};

export default NotFound;